"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BearWorkspaceUsersQuery = void 0;
var tslib_1 = require("tslib");
var UsersConverter_1 = require("../../../convertors/fromBackend/UsersConverter");
var sdk_backend_base_1 = require("@gooddata/sdk-backend-base");
var BearWorkspaceUsersQuery = /** @class */ (function () {
    function BearWorkspaceUsersQuery(authCall, workspace) {
        this.authCall = authCall;
        this.workspace = workspace;
        this.options = {};
    }
    BearWorkspaceUsersQuery.prototype.withOptions = function (options) {
        this.options = options;
        return this;
    };
    BearWorkspaceUsersQuery.prototype.queryAll = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var usersQuery;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.query()];
                    case 1:
                        usersQuery = _a.sent();
                        return [2 /*return*/, usersQuery.all()];
                }
            });
        });
    };
    BearWorkspaceUsersQuery.prototype.queryWorker = function (options) {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var search;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                search = options.search;
                return [2 /*return*/, sdk_backend_base_1.ServerPaging.for(function (_a) {
                        var limit = _a.limit, offset = _a.offset;
                        return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var data, _b, items, totalCount;
                            var _this = this;
                            return tslib_1.__generator(this, function (_c) {
                                switch (_c.label) {
                                    case 0: return [4 /*yield*/, this.authCall(function (sdk) {
                                            return sdk.project.getUserListWithPaging(_this.workspace, {
                                                prefixSearch: search,
                                                userState: "ACTIVE",
                                                offset: offset,
                                                limit: limit,
                                            });
                                        })];
                                    case 1:
                                        data = _c.sent();
                                        _b = data.userList, items = _b.items, totalCount = _b.paging.totalCount;
                                        return [2 /*return*/, {
                                                items: items.map(UsersConverter_1.convertWorkspaceUser),
                                                totalCount: totalCount,
                                            }];
                                }
                            });
                        });
                    }, (_a = this.options.limit) !== null && _a !== void 0 ? _a : 1000, this.options.offset)];
            });
        });
    };
    BearWorkspaceUsersQuery.prototype.query = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.queryWorker(this.options)];
            });
        });
    };
    return BearWorkspaceUsersQuery;
}());
exports.BearWorkspaceUsersQuery = BearWorkspaceUsersQuery;
//# sourceMappingURL=index.js.map